import BasePage from "components/basePage/BasePage";
import React, { useState } from "react";
import "./ChangePassword.scss";
import Button from "components/button/Button";
import { updateUserPassword } from "services/requests";
import { showToast } from "services/helper";
import PasswordInput from "components/input/PasswordInput";
import NewPasswordInputs from "components/input/NewPasswordInputs";
import { useNavigate } from "react-router-dom";

export default function ChangePassword() {
  //STATE
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({
    password: null,
    newPassword: null,
    confirmPassword: null,
  });
  //OTHERS
  const navigate = useNavigate();

  function disableErrorMessage(field) {
    if (errors[field]?.length > 0) {
      if (errors[field] === "As Senhas não são iguais") {
        errors.newPassword = null;
        errors.confirmPassword = null;
      } else errors[field] = null;
      setErrors({ ...errors });
    }
  }

  function onSubmit(event) {
    event?.preventDefault();
    let newErrors = {};
    if (password?.length === 0)
      newErrors.password = "A Senha parece ser inválida.";
    if (newPassword?.length === 0)
      newErrors.newPassword = "A Nova Senha parece ser inválida.";
    if (confirmPassword?.length === 0)
      newErrors.confirmPassword = "A Senha de Confirmação parece ser inválida.";
    if (newPassword !== confirmPassword) {
      newErrors.newPassword = "As Senhas não são iguais";
      newErrors.confirmPassword = "As Senhas não são iguais";
    }

    const foundError = Object.keys(newErrors).length > 0;
    if (foundError) setErrors({ ...newErrors });
    else updatePassword();
  }

  function updatePassword() {
    setLoading(true);
    let body = { oldPassword: password, newPassword: newPassword };
    updateUserPassword(body)
      .then(() => {
        showToast("Senha alterada com sucesso!", "success");
        navigate("/");
      })
      .catch(() => {
        showToast(
          "Não foi possível alterar sua senha, verifique se sua senha atual está certa ou tente novamente mais tarde.",
          "error"
        );
        setLoading(false);
      });
  }

  return (
    <BasePage title="Alterar Senha">
      <div className="form">
        <form onSubmit={onSubmit}>
          <PasswordInput
            placeholder="Senha Atual"
            error={errors?.password}
            onChange={(text) => {
              setPassword(text);
              disableErrorMessage("password");
            }}
          />
          <NewPasswordInputs
            newPassword={newPassword}
            setNewPassword={setNewPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
          />
          <div className="button-container">
            <Button text="Salvar" loading={loading} onClick={onSubmit} />
          </div>
        </form>
      </div>
    </BasePage>
  );
}
